/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.account
 */
SolarService.$inject = [
    '$q',
    '$state',
    '$window',
    '$timeout',
    'AccountAuthService',
    'AnalyticsService',
    'DisclosuresModalService',
    'IndexService',
    'UserApiConsumerService',
    'UtilService'
];
function SolarService(
    $q,
    $state,
    $window,
    $timeout,
    AccountAuthService,
    AnalyticsService,
    DisclosuresModalService,
    IndexService,
    UserApiConsumerService,
    UtilService
) {
    let _pub = {};

    _pub.PROJECT_TYPE_SOLAR = 'solar';
    _pub.DISCLOSURE_SOLAR_SERVICE = "pick_my_solar";
    _pub.isEnabled = UtilService.isFeatureEnabled("pick_my_solar");
    _pub.solarWidgetOpenedCallbacks = {};
    _pub.solarWidgetClosedCallbacks = {};
    _pub.mySolarLocation = 'mySolar';
    _pub.currentSolarProject = null;
    _pub.currentProduct = null;

    const allowedProjectTypes = UtilService.reduceToProperty(UtilService.getSiteSetting('enabled_project_types'), 'type');

    let widgetOpened = false;

    let currentSolarProjectType = _pub.PROJECT_TYPE_SOLAR;
    _pub.userProjects = null;

    if (_pub.isEnabled) {
        AccountAuthService.onEveryAuthChange('set-pickmysolar-params', function () {
            if (AccountAuthService.isAuthenticated()) {
                setPickMySolarParams();
            } else {
                if (window._PMS) {
                    window._PMS.flush();
                }
            }
        });
    }

    /**
     * Opens the Solar widget for solar v2 and runs any callbacks that need to run on widget open
     * @param shouldShowDisclosure {boolean} whether or not we should show the disclosure dialog
     * @param projectType {string} the type of the solar project which could be `solar`, `battery`or `heat_pumps`
     */
    _pub.openSolarWidget = function (shouldShowDisclosure=true, projectType=_pub.PROJECT_TYPE_SOLAR) {
        currentSolarProjectType = projectType;

        AccountAuthService.checkIfUserLoggedIn().then(() => {
            if (AccountAuthService.isAuthenticated()) {
                setPickMySolarParams();
            } else {
               setSolarProjectType();
            }
        });

        if (shouldShowDisclosure) {
            let disclosureType = _pub.DISCLOSURE_SOLAR_SERVICE;
            if (projectType !== _pub.PROJECT_TYPE_SOLAR) {
                disclosureType = projectType;
            }

            DisclosuresModalService.openThirdPartyModal(disclosureType).then((result) => {
                if (result && result.continue && _pub.isEnabled) {
                    updateLeadClasses();
                    callSolarWidgetOpenedCallbacks();
                }
            });
        } else {
            updateLeadClasses();
            callSolarWidgetOpenedCallbacks();
        }
    };

    function updateLeadClasses() {
        $('body').addClass('lead-panel-open');
        $('#call-to-action').removeClass('open');
    }

    /**
     * Closes the solar widget for solar v2 and runs any callbacks that need to run on widget close
     */
    _pub.closeSolarWidget = function () {
        $('body').removeClass('lead-panel-open');
        $('#call-to-action').addClass('open');

        if (_pub.isEnabled) {
            widgetOpened = false;
            callSolarWidgetClosedCallbacks();
        }
    };

    /**
     * Opens the solar widget for the appropriate version of solar (e.g. v1 or v2 ),
     * or takes the user to the solar tab in their profile if 'mySolar' is passed in as the location argument (solar v1 only)
     * @param location {string} which solar display to take the user to (e.g. widget or profile tab). Defaults to 'widget'.
     * @param product {Object/null} the current product data, if any, where the widget is opened.
     * @param shouldShowDisclosure {boolean} whether or not we should show the disclosure dialog
     * @param projectType {string} the type of the solar project which could be `solar` or `battery`
     */
    _pub.goToSolar = function(location='widget', product, shouldShowDisclosure=true, projectType=_pub.PROJECT_TYPE_SOLAR) {
        _pub.currentProduct = product || null;
        if (_pub.isEnabled) {
            _pub.openSolarWidget(shouldShowDisclosure, projectType);
        }
    };

    /**
     * Sends tracking events to Segment via Analytics Service.
     * @param eventName {String} - the name of the event to track
     * @param extraData {Object} - extra data to pass to Segment
     */
    _pub.trackAction = function (eventName, extraData) {
        extraData = extraData || {};
        var activeCategory = $state.params.category_code || null;
        var trackingData = {
            location: 'modal',
            type: 'solar',
            category: activeCategory
        };
        angular.merge(trackingData, extraData);
        AnalyticsService.reportEvent(eventName, trackingData, _pub.currentProduct);
    };


    /**
     * Registers a key/function pair to run every time the solar widget is opened
     * @param key
     * @param func
     */
    _pub.registerSolarWidgetOpenedCallback = function (key, func) {
        if (!_pub.solarWidgetOpenedCallbacks.hasOwnProperty(key)) {
            _pub.solarWidgetOpenedCallbacks[key] = func;
        }
    };

    /**
     * Helper function to run registered solar opened callback functions
     */
    function callSolarWidgetOpenedCallbacks() {
        widgetOpened = true;
        Object.keys(_pub.solarWidgetOpenedCallbacks).forEach(function(key) {
            _pub.solarWidgetOpenedCallbacks[key]();
        });
    }

    /**
     * Registers a key/function pair to run every time the solar widget is closed
     * @param key
     * @param func
     */
    _pub.registerSolarWidgetClosedCallback = function (key, func) {
        if (!_pub.solarWidgetClosedCallbacks.hasOwnProperty(key)) {
            _pub.solarWidgetClosedCallbacks[key] = func;
        }
    };

    /**
     * Helper function to run registered solar closed callback functions
     */
    function callSolarWidgetClosedCallbacks() {
        Object.keys(_pub.solarWidgetClosedCallbacks).forEach(function(key) {
            _pub.solarWidgetClosedCallbacks[key]();
        });
    }

    /**
     * Helper function to get solar project password
     * if other solar project exists use the same password
     * if this is first project generate one
     * @returns {string} password for project
     */
    function getOrCreateSolarPassword() {
        let pickMySolarPassword;
        const key = Object.keys(_pub.userProjects)[0];
        if (key) {
            pickMySolarPassword = _pub.userProjects[key].project_data.project_password;
        } else {
            pickMySolarPassword = UtilService.generateString(30);
        }
        return pickMySolarPassword;
    }

   /**
     * Sets the PkMS params with current solar project data.
     * If the user does not have a solar project, one is created first.
     */
    function setPickMySolarParams () {
        AccountAuthService.fetchCurrentUserInfo().then(function () {
            const userEmail = AccountAuthService.getCurrentUserEmail();
            // Check if user already has a solar project.
            // If not, create one
            _pub.getUserProjects().then(function () {
                if (_pub.currentSolarProject !== null) {
                    currentSolarProjectType = _pub.currentSolarProject.project_type;
                    let pickMySolarPassword = _pub.currentSolarProject.project_data.project_password;
                    window._PMS.setParams({
                        userData: {
                            fullname: userEmail,
                            email: userEmail,
                            password: pickMySolarPassword
                        }
                    });
                } else if (widgetOpened === true) {
                    const pickMySolarPassword = getOrCreateSolarPassword();
                    let params = {
                        project_id: null,
                        project_password: pickMySolarPassword,
                    };
                    createOrUpdateProject(params).then(() => {
                        window._PMS.setParams({
                            userData: {
                                fullname: userEmail,
                                email: userEmail,
                                password: pickMySolarPassword
                            }
                        });
                    })
                } else {
                    setSolarProjectType();
                }
            });
        });
    }

    /**
     *  Check if project type in list of allowed projects
     *  @param type - String project type
     */
    _pub.isProjectAllowed = function (type) {
        return allowedProjectTypes.find(allowedType => type === allowedType);
    };

    /**
     *  Get enabled project types list for utility and filter out not supported ones + mileage one
     *  @param projects - Array of all user projects
     */
    function getEnabledProjects(projects) {
        if (allowedProjectTypes.length > 0) {
            projects.forEach((project) => {
                const type = project.project_type;
                if (project.project_type !== 'mileage' &&  _pub.isProjectAllowed(type)) {
                    _pub.userProjects[project.project_type] = project;
                }
            });
        }
    }

    /**
     * Helper function to get all user solar projects
     *  @param deferred - Object
     */
    function initUserProjects (deferred) {
        _pub.userProjects = {};
        const url = 'api/1.0/user-profile/project/';
        UserApiConsumerService.get(url).then((response) => {
            if (response.data.length > 0) {
                getEnabledProjects(response.data);
                _pub.currentSolarProject = _pub.userProjects[currentSolarProjectType] || null;
            } else {
                _pub.currentSolarProject = null;
            }
            deferred.resolve(UtilService.objectValues(_pub.userProjects));
        }, function error (response){
            deferred.reject(response.data.message);
        });
    }

    /**
     * gets all user solar projects
     */
     _pub.getUserProjects = function() {
        var deferred = $q.defer();

        if (AccountAuthService.isAuthenticated()) {
            if (_pub.userProjects !== null) {
                _pub.currentSolarProject = _pub.userProjects[currentSolarProjectType] || null;
                deferred.resolve(UtilService.objectValues(_pub.userProjects));
            } else {
                initUserProjects(deferred);
            }
        } else {
            _pub.userProjects = null;
            deferred.resolve([]);
        }

        return deferred.promise;
    };

    /**
     * Returns the current solar project type
     * 
     * @returns {string} the current solar project type
     */
     _pub.getProjectType = () => {
         return currentSolarProjectType;
     };

    AccountAuthService.onEveryAuthChange('solar_update_project', _pub.getUserProjects);

    /**
     * takes an object of project_data and our internal project id if we want to update a project
     * @param projectData
     * @param projectId - our internal id for the project
     */
    function createOrUpdateProject(projectData, projectId) {
        var deferred = $q.defer();

        projectId = projectId || null;
        var data = {
            project_data: projectData,
            project_type: currentSolarProjectType
        };
        if (projectId !== null){
            data.id = projectId;
        }
        UserApiConsumerService.post('api/1.0/user-profile/project/', data).then(function success (response){
            _pub.currentSolarProject = response.data;
            _pub.userProjects[_pub.currentSolarProject.project_type] = _pub.currentSolarProject;
            deferred.resolve(_pub.userProjects);
        }, function error (response){
            deferred.reject(response.data.message);
        });

        return deferred.promise;
    }

    /**
     * Callback that runs when PkMS fires the signUp callback.
     */
    function signUpHook() {
        AnalyticsService.reportEvent('Get Solar Quote Clicked', {type: 'solar'});

        if (!AccountAuthService.isAuthenticated()) {
            IndexService.setSignupModalHeaders();
            IndexService.openModal('#modal-enter-email');
        }
    }

    /**
     * Sets the solar project type in the _PMS module based on the current solar project type set by the solar opener
     */
    function setSolarProjectType() {
        function getProjectTypes() {
            return [currentSolarProjectType];
        }
        if ($window._PMS) {
            $window._PMS.cbFunctions = {
                signUp: signUpHook,
                userExistenceCheck: false,
                skipSignUp: true,
                projectType: getProjectTypes,
            };
            $window._PMS.flush();
        }
    }

    return _pub;
}

module.exports = SolarService;
